<div class="flex h-screen bg-gray-100">
  <!-- Sidebar -->
  <div class="w-64 bg-white shadow-lg flex flex-col">
    <div class="p-6 border-b">
      @if (siteLogo) {
        <div class="h-8 flex items-center mb-2">
          <div *ngIf="isSvgMarkup(siteLogo)" [innerHTML]="sanitizeSvg(siteLogo)" class="[&>svg]:h-8 [&>svg]:w-auto"></div>
          <img *ngIf="!isSvgMarkup(siteLogo)" [src]="siteLogo" alt="Logo" class="h-8 w-auto object-contain">
        </div>
      } @else if (siteName) {
        <p class="font-medium text-gray-500 mb-1">{{ siteName }}</p>
      } @else {
        <p class="mb-1">&nbsp;</p>
      }
      <h2 class="text-xl font-semibold text-gray-800">Site Management</h2>
    </div>
    <nav class="mt-6 flex-1">
      @if (auth.canManageUsers$ | async) {
        <a
          routerLink="users"
          routerLinkActive="bg-blue-50 text-blue-700 border-r-2 border-blue-700"
          class="flex items-center px-6 py-3 text-gray-700 hover:bg-gray-50 transition-colors"
        >
          <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13.5 3a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"></path>
          </svg>
          Users
        </a>
        <a
          routerLink="settings"
          routerLinkActive="bg-blue-50 text-blue-700 border-r-2 border-blue-700"
          class="flex items-center px-6 py-3 text-gray-700 hover:bg-gray-50 transition-colors"
        >
          <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
          </svg>
          Settings
        </a>
      }
      <a 
        routerLink="pages" 
        routerLinkActive="bg-blue-50 text-blue-700 border-r-2 border-blue-700"
        class="flex items-center px-6 py-3 text-gray-700 hover:bg-gray-50 transition-colors"
      >
        <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
        </svg>
        Pages
      </a>
      <a 
        routerLink="articles" 
        routerLinkActive="bg-blue-50 text-blue-700 border-r-2 border-blue-700"
        class="flex items-center px-6 py-3 text-gray-700 hover:bg-gray-50 transition-colors"
      >
        <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"></path>
        </svg>
        Articles
      </a>
      <a 
        routerLink="profiles" 
        routerLinkActive="bg-blue-50 text-blue-700 border-r-2 border-blue-700"
        class="flex items-center px-6 py-3 text-gray-700 hover:bg-gray-50 transition-colors"
      >
        <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
        </svg>
        Profiles
      </a>
      <a
        routerLink="navigation"
        routerLinkActive="bg-blue-50 text-blue-700 border-r-2 border-blue-700"
        class="flex items-center px-6 py-3 text-gray-700 hover:bg-gray-50 transition-colors"
      >
        <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
        Navigation
      </a>
      <a
        routerLink="redirects"
        routerLinkActive="bg-blue-50 text-blue-700 border-r-2 border-blue-700"
        class="flex items-center px-6 py-3 text-gray-700 hover:bg-gray-50 transition-colors"
      >
        <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
        </svg>
        Redirects
      </a>
    </nav>
    <div class="border-t border-gray-200 mt-auto">
      <a
        routerLink="/sites"
        class="flex items-center px-6 py-3 text-gray-700 hover:bg-gray-50 transition-colors"
      >
        <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
        </svg>
        Back to Sites
      </a>
      @if (auth.session$ | async; as session) {
        <div class="border-t border-gray-200 px-6 py-4">
          <p class="text-xs text-gray-500 mb-1">Signed in as</p>
          <p class="text-sm text-gray-800 truncate" [title]="session.email">{{ session.email }}</p>
          <button (click)="logout()" class="mt-2 text-sm text-blue-600 hover:underline">
            Sign out
          </button>
        </div>
      }
    </div>
  </div>

  <!-- Main Content -->
  <div class="flex-1 overflow-auto">
    <router-outlet></router-outlet>
  </div>
</div>